import { render, staticRenderFns } from "./OrderFromLink.vue?vue&type=template&id=04c7d378&scoped=true"
import script from "./OrderFromLink.vue?vue&type=script&lang=js"
export * from "./OrderFromLink.vue?vue&type=script&lang=js"
import style0 from "./OrderFromLink.vue?vue&type=style&index=0&id=04c7d378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7d378",
  null
  
)

export default component.exports